import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { getCurrentWeekDates } from "../utils";

// ── palette
const PKG_PALETTE      = ["#2563eb","#7c3aed","#0d9488","#f59e0b","#ec4899","#06b6d4","#94a3b8"];
const PKG_PALETTE_BG   = ["#eff6ff","#f5f3ff","#f0fdfa","#fffbeb","#fdf2f8","#ecfeff","#f1f5f9"];
const PKG_PALETTE_TEXT = ["#2563eb","#7c3aed","#0d9488","#d97706","#db2777","#0891b2","#475569"];
const PKG_CIRCUM = 2 * Math.PI * 15.9;

const buildSegments = (rawData) => {
  if (!rawData?.keys?.length) return [];
  const pairs = rawData.keys
    .map((name, i) => ({ name, count: parseInt(rawData.values[i], 10) || 0 }))
    .filter((p) => p.name !== "")
    .sort((a, b) => b.count - a.count);
  const total = pairs.reduce((s, p) => s + p.count, 0);
  if (!total) return [];
  const top = pairs.slice(0, 6);
  const othersCount = pairs.slice(6).reduce((s, p) => s + p.count, 0);
  const rows = top.map((p, i) => ({
    name: p.name,
    count: p.count,
    pct: Math.round((p.count / total) * 100),
    color: PKG_PALETTE[i],
    bg: PKG_PALETTE_BG[i],
    textColor: PKG_PALETTE_TEXT[i],
  }));
  if (othersCount > 0) rows.push({ name: "Others", count: othersCount, pct: Math.round((othersCount / total) * 100), color: PKG_PALETTE[6], bg: PKG_PALETTE_BG[6], textColor: PKG_PALETTE_TEXT[6] });
  let offset = 0;
  return rows.map((row) => {
    const len = (row.pct / 100) * PKG_CIRCUM;
    const seg = { ...row, dasharray: `${len.toFixed(2)} ${(PKG_CIRCUM - len).toFixed(2)}`, dashoffset: -offset };
    offset += len;
    return seg;
  });
};

// let dataLoaded = false;

const TopFivePackageSection = ({ productType }) => {
  const [renderJsxStatus, setRenderJsxStatus] = useState(false);
  const [pieDataCurrentMonth, setPieDataCurrentMonth] = useState(true);
  const [reRenderComponent, setReRenderComponent] = useState(false);
  const [loginData, setLoginData] = useState("");
  const [pieDataPastMonth, setPieDataPastMonth] = useState(false);
  const [clientPreference, setClientPreference] = useState("");
  const [fetchedData, setFetchedData] = useState("");
  const [loader, setLoader] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState("currentWeek");

  window.addEventListener("storage", (e) => {
    // console.log("something got changed.")
    setReRenderComponent(!reRenderComponent);
  });

  // fetch data from local storage
  useEffect(() => {
    setPieDataCurrentMonth(false);
    setPieDataPastMonth(false);

    // let homepageData = JSON.parse(localStorage.getItem('homepageData'));
    let loginInfo = JSON.parse(localStorage.getItem("loginDetails"));
    let clientPreferenceInfo = JSON.parse(
      localStorage.getItem("clientPreference")
    );

    if (true) {
      //   setFetchedData(homepageData);
      setRenderJsxStatus(true);
    }
    if (loginInfo) {
      setLoginData(loginInfo);
    }
    if (clientPreferenceInfo) {
      setClientPreference(clientPreferenceInfo);
    }
  }, []);

  const getIndividualPackageCounts = async (startDate, endDate) => {
    setLoader(true);
    const clientPreference = JSON.parse(
      localStorage.getItem("clientPreference")
    );
    const orgPreference = JSON.parse(localStorage.getItem("orgPreference"));

    const clientIdPreference = JSON.parse(
      localStorage.getItem("clientIdPreference")
    );
    const idToken = localStorage.getItem("idTokenBilling");
    const configBody = {
      headers: {
        authorization: idToken,
      },
      method: "get",
      url: `https://api.niroggyan.com/billing/${productType}/counts?query_on=packages&query_by=range&start=${startDate}&end=${endDate}${
        orgPreference && clientPreference
          ? `&org=${orgPreference}&center=${clientPreference}`
          : ""
      }${clientIdPreference ? `&clientId=${clientIdPreference}` : ``}`,
      validateStatus: function (status) {
        return (status >= 200) & (status < 510);
      },
    };
    const response = await axios(configBody);
    setLoader(false);
    return response;
    // setFetchedData(response.data);
  };

  const formattedStartDate = (date) => {
    const dateInFormat = new Date(date);
    const requiredTime = `${dateInFormat.getFullYear()}-${
      dateInFormat.getMonth() >= 9
        ? dateInFormat.getMonth() + 1
        : `0${dateInFormat.getMonth() + 1}`
    }-${
      dateInFormat.getDate() > 10
        ? dateInFormat.getDate()
        : `0${dateInFormat.getDate()}`
    } 00:00:00.000`;
    return requiredTime;
  };

  const formattedEndDate = (date) => {
    const dateInFormat = new Date(date);
    const requiredTime = `${dateInFormat.getFullYear()}-${
      dateInFormat.getMonth() >= 9
        ? dateInFormat.getMonth() + 1
        : `0${dateInFormat.getMonth() + 1}`
    }-${
      dateInFormat.getDate() > 10
        ? dateInFormat.getDate()
        : `0${dateInFormat.getDate()}`
    } 23:59:59.999`;
    return requiredTime;
  };

  const getCurrentMonthStartEndDates = () => {
    let todaysDate = new Date();
    let startDate = new Date(
      todaysDate.getFullYear(),
      todaysDate.getMonth(),
      1,
      0,
      0,
      0,
      0
    );

    return {
      startDate: formattedStartDate(startDate),
      endDate: formattedEndDate(todaysDate),
    };
  };

  const getPreviousMonthStartEndDates = () => {
    let todaysDate = new Date();
    const startDate = new Date(
      todaysDate.getFullYear(),
      todaysDate.getMonth() - 1,
      1,
      0,
      0,
      0,
      0
    );
    const endDate = new Date(
      todaysDate.getFullYear(),
      todaysDate.getMonth(),
      0,
      23,
      59,
      59,
      0
    );
    return {
      startDate: formattedStartDate(startDate),
      endDate: formattedEndDate(endDate),
    };
  };

  const currentMonthPackageWiseCounts = async () => {
    const startDate = getCurrentMonthStartEndDates().startDate;
    const endDate = getCurrentMonthStartEndDates().endDate;
    (async function () {
      const response = await getIndividualPackageCounts(startDate, endDate);
      setFetchedData(response.data.data);
    })();
  };

  const currentWeekPackageWiseCounts = async () => {
    const startDate = getCurrentWeekDates().startDate;
    const endDate = getCurrentWeekDates().endDate;
    (async function () {
      const response = await getIndividualPackageCounts(startDate, endDate);
      setFetchedData(response.data.data);
    })();
  };

  const PreviousMonthPackageWiseCounts = async () => {
    const startDate = getPreviousMonthStartEndDates().startDate;
    const endDate = getPreviousMonthStartEndDates().endDate;
    (async function () {
      const response = await getIndividualPackageCounts(startDate, endDate);
      console.log("previous Response", response);
      setFetchedData(response.data.data);
    })();
  };

  const getCurrentWeekPackageDataOnLoad = () => {
    const storedCurrentWeekPackagesData = JSON.parse(
      localStorage.getItem("currentWeekPackagesData")
    );

    if (
      storedCurrentWeekPackagesData &&
      Object.keys(storedCurrentWeekPackagesData)?.length
    ) {
      setFetchedData(storedCurrentWeekPackagesData);
    } else {
      (async function () {
        const today = new Date().getDate();

        const startDate = getCurrentWeekDates().startDate;
        const endDate = getCurrentWeekDates().endDate;

        const response = await getIndividualPackageCounts(startDate, endDate);
        setFetchedData(response.data.data);
        localStorage.setItem(
          "currentWeekPackagesData",
          JSON.stringify(response.data.data)
        );
      })();
    }
  };

  const getCurrentMonthPackageDataOnLoad = () => {
    const storedCurrentMonthPackagesData = JSON.parse(
      localStorage.getItem("currentMonthPackagesData")
    );

    if (
      storedCurrentMonthPackagesData &&
      Object.keys(storedCurrentMonthPackagesData)?.length
    ) {
      setFetchedData(storedCurrentMonthPackagesData);
    } else {
      (async function () {
        const today = new Date().getDate();

        const startDate = getCurrentMonthStartEndDates().startDate;
        const endDate = getCurrentMonthStartEndDates().endDate;

        const response = await getIndividualPackageCounts(startDate, endDate);
        setFetchedData(response.data.data);
        localStorage.setItem(
          "currentMonthPackagesData",
          JSON.stringify(response.data.data)
        );
      })();
    }
  };

  useEffect(() => {
    localStorage.removeItem("currentWeekPackagesData");
    localStorage.removeItem("currentMonthPackagesData");
  }, [productType]);

  useEffect(() => {
    const today = new Date().getDay();
    if (today < 3) {
      setSelectedMetric("currentMonth");
      getCurrentMonthPackageDataOnLoad();
    } else {
      setSelectedMetric("currentWeek");
      getCurrentWeekPackageDataOnLoad();
    }
  }, [productType]);

  let top5packagesPercentages = [];
  let totalOfAll5Package = [];
  let top5packages = [];

  // sum of all top 5 package counts
  totalOfAll5Package = fetchedData
    ? fetchedData.values.reduce(
        (partialSum, a) => parseInt(partialSum) + parseInt(a),
        0
      )
    : "";

  top5packages = fetchedData ? fetchedData.keys : "";

  for (let i = 0; i < top5packages.length; i++) {
    let reportCountOfPackage = fetchedData.values[i];
    let percentageOfReportCount = Math.round(
      (reportCountOfPackage / totalOfAll5Package) * 100
    );
    top5packagesPercentages.push(percentageOfReportCount);
  }

  // sorting in packages in descending order
  top5packagesPercentages.sort(function (a, b) {
    return b - a;
  });

  let colorsForTop5Packages = [
    "#3567D6",
    "#3CD0FF",
    "#22C55E",
    "#F7B217",
    "#FF6D00",
  ];

  // pie chart
  let allTheData = {
    series: top5packagesPercentages,
    options: {
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          return opts.w.config.series[opts.seriesIndex] + "%";
        },
      },
      colors: colorsForTop5Packages,
      legend: {
        show: false,
      },
      chart: {
        width: "380px",
        type: "pie",
      },
      labels: top5packages,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
          },
        },
      ],
    },
  };

  const handleSelection = async (e) => {
    setSelectedMetric(e.target.value);
    switch (e.target.value) {
      case "currentMonth":
        setPieDataCurrentMonth(true);
        setPieDataPastMonth(false);
        !pieDataCurrentMonth && (await currentMonthPackageWiseCounts());
        break;
      case "previousMonth":
        setPieDataCurrentMonth(false);
        setPieDataPastMonth(false);
        await PreviousMonthPackageWiseCounts();
        break;
      case "currentWeek":
        setPieDataCurrentMonth(false);
        setPieDataPastMonth(false);
        await currentWeekPackageWiseCounts();
        break;
      default:
    }
  };

  let regrex = /WellWise|Wellwise|wellwise/gi;

  const segments = buildSegments(fetchedData);
  const maxCount = segments.length > 0 ? segments[0].count : 1;
  const namedCount = segments.filter((s) => s.name !== "Others").length;
  const periodLabels = { currentWeek: "Current Week", currentMonth: "Current Month", previousMonth: "Previous Month" };

  // ── skeleton rows while loading
  const SkeletonView = () => (
    <Stack direction="row" gap={4} alignItems="flex-start" mt={1}>
      {/* donut skeleton */}
      <Stack gap={2} sx={{ minWidth: 200, flexShrink: 0 }}>
        <Skeleton variant="circular" width={180} height={180} />
        {[1,2,3,4].map((k) => (
          <Stack key={k} direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%" }}>
            <Stack direction="row" gap={1} alignItems="center">
              <Skeleton variant="circular" width={10} height={10} />
              <Skeleton variant="text" width={110} height={14} />
            </Stack>
            <Skeleton variant="text" width={32} height={14} />
          </Stack>
        ))}
      </Stack>
      {/* table skeleton */}
      <Stack flexGrow={1} gap={1.5} sx={{ minWidth: 0 }}>
        <Stack direction="row" gap={2} pb={0.5}>
          <Skeleton variant="text" width={24} height={14} sx={{ flexShrink: 0 }} />
          <Skeleton variant="text" width="25%" height={14} />
          <Skeleton variant="text" sx={{ flexGrow: 1 }} height={14} />
          <Skeleton variant="text" width={72} height={14} sx={{ flexShrink: 0 }} />
        </Stack>
        {[1,2,3,4,5,6,7].map((k) => (
          <Stack key={k} direction="row" gap={2} alignItems="center">
            <Skeleton variant="text" width={20} height={14} sx={{ flexShrink: 0 }} />
            <Skeleton variant="text" width="28%" height={14} sx={{ flexShrink: 0 }} />
            <Box sx={{ flexGrow: 1 }}>
              <Skeleton variant="rectangular" width="100%" height={6} sx={{ borderRadius: "3px" }} />
            </Box>
            <Skeleton variant="rectangular" width={80} height={22} sx={{ borderRadius: "6px", flexShrink: 0 }} />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );

  // ── empty / no-data view
  const EmptyPackageView = () => (
    <Stack alignItems="center" justifyContent="center" gap={2} py={5}>
      <Box
        sx={{
          width: 72, height: 72, borderRadius: "50%",
          background: "#f1f5f9",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}
      >
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
          <path d="M20 7H4C2.9 7 2 7.9 2 9v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 3H8L6 7h12l-2-4z" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 12v4M10 14h4" stroke="#cbd5e1" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#475569", mb: 0.5 }}>
          No Package Data Available
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#94a3b8", maxWidth: 280 }}>
          Package distribution data is not available for this period. Try switching to a different time range.
        </Typography>
      </Box>
    </Stack>
  );

  const renderJSX = () => (
    <Box p={0} flexGrow={1} alignSelf="stretch">
      {/* ── Header ── */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={2.5} gap={2}>
        <Box>
          <Typography sx={{ fontWeight: 800, fontSize: "15px", color: "#170C6B", mb: 0.3 }}>
            {loginData && loginData.role === "LIS" && clientPreference === "none"
              ? "Report Type Distribution"
              : "Top Health Packages"}
          </Typography>
          <Typography sx={{ fontSize: "11.5px", color: "#9DA3AE" }}>
            Most-used packages in the selected period
          </Typography>
        </Box>
        <Stack direction="row" gap={0.75} flexShrink={0} sx={{ background: "#F0F4FF", borderRadius: "10px", p: "4px" }}>
          {["currentWeek", "currentMonth", "previousMonth"].map((key) => (
            <Box key={key} onClick={() => handleSelection({ target: { value: key } })}
              sx={{ px: 1.5, py: 0.6, borderRadius: "7px", cursor: "pointer", background: selectedMetric === key ? "#3567D6" : "transparent", transition: "background 0.18s ease" }}
            >
              <Typography sx={{ fontSize: "11px", fontWeight: 700, color: selectedMetric === key ? "#fff" : "#8897C4", whiteSpace: "nowrap", transition: "color 0.18s ease" }}>
                {periodLabels[key]}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Stack>

      {/* ── Body ── */}
      {loader ? (
        <SkeletonView />
      ) : segments.length === 0 ? (
        <EmptyPackageView />
      ) : (
        <Stack direction="row" gap={4} flexWrap={{ xs: "wrap", md: "nowrap" }} alignItems="flex-start">
          {/* ── Left: Donut + Legend ── */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, minWidth: 200 }}>
            <Box sx={{ position: "relative", width: 180, height: 180 }}>
              <svg viewBox="0 0 36 36" style={{ width: "100%", height: "100%", transform: "rotate(-90deg)" }}>
                {segments.map((seg, i) => (
                  <circle key={i} cx="18" cy="18" r="15.9" fill="none" stroke={seg.color}
                    strokeWidth="3.8" strokeDasharray={seg.dasharray} strokeDashoffset={seg.dashoffset} />
                ))}
              </svg>
              <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", textAlign: "center", pointerEvents: "none" }}>
                <Typography sx={{ fontWeight: 700, fontSize: "28px", lineHeight: 1, color: "#1e293b" }}>{namedCount}</Typography>
                <Typography sx={{ fontSize: "11px", color: "#94a3b8", mt: "2px" }}>Packages</Typography>
              </Box>
            </Box>
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 0.75 }}>
              {segments.map((seg, i) => (
                <Stack key={i} direction="row" alignItems="center" justifyContent="space-between" gap={1}>
                  <Stack direction="row" alignItems="center" gap={0.75}>
                    <Box sx={{ width: 10, height: 10, borderRadius: "50%", background: seg.color, flexShrink: 0 }} />
                    <Typography sx={{ fontSize: "12px", color: "#374151", maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {loginData?.displayName === "Dummy User" ? seg.name?.replace(regrex, "HealthCheck") : seg.name}
                    </Typography>
                  </Stack>
                  <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#374151", flexShrink: 0 }}>{seg.pct}%</Typography>
                </Stack>
              ))}
            </Box>
          </Box>

          {/* ── Right: Table ── */}
          <TableContainer sx={{ flexGrow: 1 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {["#", "Health Package", "Share", "Count"].map((h) => (
                    <TableCell key={h} sx={{ fontSize: "11px", fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #e2e8f0", pb: 1.5, whiteSpace: "nowrap", ...(h === "Share" ? { minWidth: 140 } : {}) }}>
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {segments.map((seg, i) => (
                  <TableRow key={i} sx={{ "&:last-child td": { border: 0 }, "&:hover": { background: "#f8fafc" } }}>
                    <TableCell sx={{ color: "#94a3b8", fontSize: "12px", width: 28, py: 1.5 }}>
                      {seg.name === "Others" ? "" : i + 1}
                    </TableCell>
                    <TableCell sx={{ fontSize: "13px", fontWeight: 500, color: "#1e293b", py: 1.5 }}>
                      {loginData?.displayName === "Dummy User" ? seg.name?.replace(regrex, "HealthCheck") : seg.name}
                    </TableCell>
                    <TableCell sx={{ minWidth: 140, py: 1.5 }}>
                      <Box sx={{ height: 6, borderRadius: 3, background: "#e2e8f0", overflow: "hidden" }}>
                        <Box sx={{ height: "100%", width: `${Math.round((seg.count / maxCount) * 100)}%`, background: seg.color, borderRadius: 3 }} />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: 1.5 }}>
                      <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: "4px", background: seg.bg, color: seg.textColor, fontWeight: 600, fontSize: "12px", borderRadius: "6px", px: 1, py: 0.4, whiteSpace: "nowrap" }}>
                        {seg.count.toLocaleString("en-IN")}
                        <Box component="span" sx={{ opacity: 0.65, fontWeight: 400 }}>&nbsp;{seg.pct}%</Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      )}
    </Box>
  );

  // const renderJSX = () => {
  //   return (
  //     <div className="mb-4">
  //       <Card>
  //         <Card.Body>
  //           <Card.Title className="topFivePackageButtonsCss">
  //             <div>
  //               {loginData &&
  //               loginData.role === "LIS" &&
  //               clientPreference === "none"
  //                 ? "Report Type Distribution"
  //                 : "Top Five Packages"}
  //             </div>
  //             {/* <div className="topFivePackageButtonsMarginsCss">
  //               <button
  //                 style={{
  //                   color:
  //                     pieDataCurrentMonth && !pieDataPastMonth ? "#fff" : "",
  //                   backgroundColor:
  //                     pieDataCurrentMonth && !pieDataPastMonth ? "#3567D6" : "",
  //                 }}
  //                 onClick={async () => {
  //                   setPieDataCurrentMonth(true);
  //                   setPieDataPastMonth(false);
  //                   !pieDataCurrentMonth &&
  //                     (await currentMonthPackageWiseCounts());
  //                 }}
  //                 className="top5packageButtonCss"
  //               >
  //                 <span className="packageCurrentMonthTextCss"></span>
  //               </button>
  //               <button
  //                 style={{
  //                   color:
  //                     !pieDataCurrentMonth && !pieDataPastMonth ? "#fff" : "",
  //                   backgroundColor:
  //                     !pieDataCurrentMonth && !pieDataPastMonth
  //                       ? "#3567D6"
  //                       : "",
  //                 }}
  //                 onClick={async () => {
  //                   setPieDataCurrentMonth(false);
  //                   setPieDataPastMonth(false);
  //                   await PreviousMonthPackageWiseCounts();
  //                 }}
  //                 className="top5packageButtonCss"
  //               >
  //                 <span className="packagePreviousMonthTextCss"></span>
  //               </button>
  //               <button
  //                 style={{
  //                   display:
  //                     loginData &&
  //                     loginData.role === "admin" &&
  //                     clientPreference === "none"
  //                       ? ""
  //                       : "none",
  //                   color:
  //                     pieDataPastMonth && !pieDataCurrentMonth ? "#fff" : "",
  //                   backgroundColor:
  //                     pieDataPastMonth && !pieDataCurrentMonth ? "#3567D6" : "",
  //                 }}
  //                 onClick={() => {
  //                   setPieDataCurrentMonth(false);
  //                   setPieDataPastMonth(true);
  //                 }}
  //                 className="top5packageButtonCss"
  //               >
  //                 <span className="packagePastMonthTextCss"></span>
  //               </button>
  //             </div> */}
  //           </Card.Title>

  //           <div className="pieContentsResolutionCss">
  //             <div
  //               className={
  //                 top5packagesPercentages.length === 0
  //                   ? ""
  //                   : "pieLeftContentCss"
  //               }
  //               style={{ display: "flex", justifyContent: "center" }}
  //             >
  //               <Card.Subtitle>
  //                 {top5packagesPercentages.length === 0 && !loader ? (
  //                   <span style={{ color: "#7787bc" }}>
  //                     <span>No Data to display</span>
  //                   </span>
  //                 ) : loader ? (
  //                   <Spinner animation="border" size="sm" />
  //                 ) : (
  //                   // <ReactApexChart
  //                   //   options={allTheData.options}
  //                   //   series={allTheData.series}
  //                   //   type="pie"
  //                   //   width={380}
  //                   // />
  //                   renderTable()
  //                 )}
  //               </Card.Subtitle>
  //             </div>

  //             <div className="pieRightContentCssWidth">
  //               {/* Current Month Count (for pie chart left content) */}
  //               <span
  //                 style={{
  //                   display: pieDataCurrentMonth && !pieDataPastMonth ? "" : "",
  //                 }}
  //               >
  //                 {fetchedData &&
  //                   fetchedData.keys.map((each, idx) => (
  //                     <>
  //                       <div key={each - idx} style={{ marginBottom: "2px" }}>
  //                         <div className="pieRightContentLineHeaderCss">
  //                           {each} {"("} {fetchedData.values[idx]} {")"} {""}{" "}
  //                           {Math.round(
  //                             (fetchedData.values[idx] / totalOfAll5Package) *
  //                               100
  //                           )}
  //                           {"%"}
  //                         </div>
  //                         <Line
  //                           className="pieRightContentLineCss"
  //                           percent={Math.round(
  //                             (fetchedData.values[idx] / totalOfAll5Package) *
  //                               100
  //                           )}
  //                           strokeColor={colorsForTop5Packages[idx]}
  //                         />
  //                       </div>
  //                     </>
  //                   ))}
  //               </span>
  //             </div>
  //           </div>
  //         </Card.Body>
  //       </Card>
  //     </div>
  //   );
  // };

  return <>{renderJsxStatus ? renderJSX() : ""}</>;
};

export default TopFivePackageSection;
